import { render, staticRenderFns } from "./expense-modal.vue?vue&type=template&id=4e33326a&"
import script from "./expense-modal.vue?vue&type=script&lang=js&"
export * from "./expense-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports